export default [
  {
    width: 5,
    header: {
      type: 'text',
      caption: 'Id',
    },
    cell: {
      type: 'text',
      value: (e) => e.id,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Name',
    },
    cell: {
      type: 'text',
      value: (e) => e.name,
    },
  },
  {
    width: 8,
    header: {
      type: 'text',
      caption: 'Type',
    },
    cell: {
      type: 'text',
      value: (e) => e.type,
    },
  },
  {
    width: 8,
    header: {
      type: 'text',
      caption: 'payInLimit',
    },
    cell: {
      type: 'slot',
      name: 'payInLimit',
    },
  },
  {
    width: 14,
    header: {
      type: 'text',
      caption: 'payInFee',
    },
    cell: {
      type: 'slot',
      name: 'payInFee',
    },
  },
  {
    width: 8,
    header: {
      type: 'text',
      caption: 'payOutLimit',
    },
    cell: {
      type: 'slot',
      name: 'payOutLimit',
    },
  },
  {
    width: 14,
    header: {
      type: 'text',
      caption: 'payOutFee',
    },
    cell: {
      type: 'slot',
      name: 'payOutFee',
    },
  },
  {
    width: 5,
    header: {
      type: 'text',
      caption: 'Currency',
    },
    cell: {
      type: 'text',
      value: (e) => e.currency,
    },
  },
  {
    width: 9,
    header: {
      type: 'text',
      caption: 'Network',
    },
    cell: {
      type: 'text',
      value: (e) => e.network,
    },
  },
  {
    width: 6,
    header: {
      type: 'text',
      caption: '',
    },
    cell: {
      type: 'slot',
      name: 'edit',
    },
  },
];
